import { render } from "./Withdraw.vue?vue&type=template&id=0215b258&scoped=true&ts=true"
import script from "./Withdraw.vue?vue&type=script&lang=ts"
export * from "./Withdraw.vue?vue&type=script&lang=ts"

import "./Withdraw.vue?vue&type=style&index=0&id=0215b258&scoped=true&lang=scss"

import exportComponent from "D:\\Project\\wallet\\wallet-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0215b258"]])

export default __exports__